<!--
    File: Schedule.vue
-->

<template>
  <v-container fluid>
    <v-row>
      <v-col sm="12" md="6" :class="{'pa-0': $vuetify.breakpoint.smAndDown}">        
        <v-card outlined>
          <v-toolbar class="elevation-0" color="background">
            <v-toolbar-title>
              수업 스케줄 관리{{studio == 3 ? ' (판교점)' : studio == 6 ? ' (분당점)' : ''}}
            </v-toolbar-title>

            <v-row v-if="login.studio == 3" class="mr-3" justify="end">
                <a v-if="studio == 6" @click="change(3)">판교점</a><span v-if="studio == 3">판교점</span>
                <span class="ml-3 mr-3">|</span>
                <a v-if="studio == 3" @click="change(6)">분당점</a><span v-if="studio == 6">분당점</span>
            </v-row>

          </v-toolbar>
          <v-row class="pa-3 mb--40" align="center">
            <v-col cols="2" class="pt-0">{{$vuetify.breakpoint.mdAndUp ? "수업기간" : "기간"}}</v-col>
            <v-col cols="4"><v-text-field class="pt-2 font-13" v-model="date[0]" type="date"/></v-col>
            <v-col cols="1" class="pt-0 text-center">~</v-col>
            <v-col cols="4"><v-text-field class="pt-2 font-13" v-model="date[1]" type="date" v-on:input="getSchedule()"/></v-col>
            <v-col cols="1"><v-icon v-if="$vuetify.breakpoint.mdAndUp" @click="refresh()">mdi-refresh</v-icon></v-col>
          </v-row>

          <v-row class="pl-3 pr-3" >
            <v-divider />
          </v-row>

          <v-row v-if="pages == 0" class="pa-3">
            <v-col cols="12" class="mb-3 text-center">해당 기간에 수업이 없습니다.</v-col>
          </v-row>

          <v-list class="pa-3">
            <v-list-item v-for="(schedule, i) in schedules.slice(offset, offset + 10)" :key="i" @click="setInfo(schedule)">
              <v-list-item-title v-if="$vuetify.breakpoint.mdAndUp" v-text="schedule.date" />
              <v-list-item-title v-if="$vuetify.breakpoint.smAndDown" v-text="schedule.date.substring(5, 10)" />
              <v-list-item-title v-text="schedule.time" />
              <v-list-item-subtitle v-text="getLesson(schedule.lesson).text" />
              <v-list-item-subtitle v-text="'(정원 ' + schedule.capacity + '명)'" />
              <v-list-item-subtitle v-text="getInstructor(schedule.instructor).text" />
            </v-list-item>
          </v-list>

          <v-row v-if="pages == 1" class="pa-3" />
          <v-row v-if="pages > 1" class="pa-3">
            <v-divider />
          </v-row>
          <v-row v-if="pages > 1" class="ma-3" justify="center">
            <v-pagination circle v-model="page" :length="pages" @input="move()"/>
          </v-row>
        </v-card>
        <v-row class="pa-3" align="center">
          <v-col cols="6">
            <v-btn color="primary elevation-0" @click="add()" v-if="edit == null">추가</v-btn>
          </v-col>
          <v-col cols="6" class="text-right" v-if="schedules.length">{{schedules.length}}</v-col>
        </v-row>
      </v-col>

      <v-col sm="12" md="6" v-if="schedule || edit" :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
        <v-card outlined>
          <v-toolbar class="mb-3 elevation-0" color="background">
            <v-toolbar-title>{{subtitle}}</v-toolbar-title>
          </v-toolbar>

          <v-row class="pt-3 pl-3 pr-3" v-for="(column, i) in columns" :key="i" align-top>
            <v-col cols="1"><v-icon>{{column.icon}}</v-icon></v-col>
            <v-col cols="3" class="font-weight-light">{{column.title}}</v-col>            
            <v-col cols="8" v-if="edit == null || i == 4 || i >= 8">{{column.text}}</v-col>

            <v-col cols="8" v-if="edit && i == 0" class="mb--20">
              <v-text-field class="pa-0 mt--5 font-14" v-model="edit.date" type="date" />
            </v-col>

            <v-col cols="8" v-if="edit && i == 1" class="mb--20">
              <v-text-field class="pa-0 mt--5 font-14" v-model="edit.time" type="time" />
            </v-col>

            <v-col cols="8" v-if="edit && i == 2" class="mb--20">
              <v-row>
                <v-col><v-text-field class="pa-0 mt--5 font-14" v-model="edit.capacity" type="number" /></v-col>
                <v-col v-if="edit.booked">(예약: {{edit.booked}}명)</v-col>
              </v-row>
            </v-col>

            <v-col cols="8" v-if="edit && i == 3" class="mb--20">
              <v-select class="pa-0 mt--5 font-14" v-model="edit.lesson" :items="lessons" @change="setCoupon()" />
            </v-col>

            <v-col cols="8" v-if="edit && i == 5" class="mb--20">
              <v-select class="pa-0 mt--5 font-14" v-model="edit.instructor" :items="instructors" />
            </v-col>

            <v-col cols="8" v-if="edit && i == 6" class="mb--20">
              <v-textarea class="pa-0 mt--5 font-14" v-model="edit.memo" rows="1" counter auto-grow />
            </v-col>

            <v-col cols="8" v-if="edit && i == 7" class="mb--20">
              <v-select class="pa-0 mt--5 font-14" v-model="edit.cancel" :items="cancels" />
            </v-col>
          </v-row>
          <v-spacer class="pa-3"/>
          <v-divider />
          <v-row class="pa-3" align="center" justify="end">
            <v-col class="text-left" v-if="edit == null && schedule.booked == 0">
              <v-btn color="accent" elevation="0" @click="remove()">삭제</v-btn>
            </v-col>
            <v-col class="text-right" v-if="edit == null">
              <v-btn color="primary" elevation="0" @click="modify()">수정</v-btn>
            </v-col>
            <v-col class="text-right" v-if="edit">
              <v-btn color="normal" @click="cancel()" class="mr-3 elevation-0">취소</v-btn>
              <v-btn v-if="this.schedule == null" color="secondary" elevation="0" @click="insert()">등록</v-btn>
              <v-btn v-if="this.schedule" color="secondary" elevation="0" @click="update()">적용</v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import util from '../utils/util'

export default {
  data () {
    return {
      login: null,
      date: [ '', '' ],
      lesson: '전체',
      lessons: [],
      schedules: [],
      instructors: [],
      couponTypes: [],
      schedule: null,
      edit: null,
      subtitle: null,
      columns: [
        { icon: 'mdi-calendar', title: '날자', text: '' },
        { icon: 'mdi-clock-outline', title: '시간', text: '' },
        { icon: 'mdi-account-multiple', title: '정원', text: '' },
        { icon: 'mdi-tag', title: '수업', text: '' },
        { icon: 'mdi-ticket', title: '쿠폰', text: '' },
        { icon: 'mdi-account-star', title: '강사', text: '' },
        { icon: 'mdi-pencil', title: '메모', text: '' },
        { icon: 'mdi-book-remove', title: '예약취소', text: '' },
        { icon: 'mdi-calendar-plus', title: '등록일시', text: '' },
        { icon: 'mdi-calendar-refresh', title: '수정일시', text: '' }
      ],
      cancels: [
        { value: 2, text: '2시간 전에 가능' },
        { value: 4, text: '4시간 전에 가능' },
        { value: 6, text: '6시간 전에 가능' },
        { value: 8, text: '8시간 전에 가능' },
        { value: 12, text: '12시간 전에 가능' },
        { value: 24, text: '하루 전에 가능' },
        { value: 48, text: '이틀 전에 가능' }
      ],
      page: 1,
      pages: 0,
      offset: 0,
      studio: 0,
    }
  },

  methods: {
    move: function () {
      this.offset = (this.page - 1) * 10
    },

    refresh: function () {
      this.date[0] = util.getDateOfMonth(new Date, 0)
      this.date[1] = util.getDateOfMonth(new Date, 2)

      this.getSchedule()
    },

    getLesson: function (id) {
      return util.getItem(this.lessons, id)
    },

    getInstructor: function (id) {
      return util.getItem(this.instructors, id)
    },

    getSchedule: function () {
      this.cancel()

      axios.get(`/api/schedule/list/${this.studio}/${this.date[0] }/${this.date[1]}`)
      .then(response => {
        if (response.data.error)
          console.log(response.data.error)
        else {
          this.schedule = null
          this.schedules = response.data.list
          this.pages = Math.ceil(this.schedules.length / 10)
          this.page = 1
          this.move()
        }
      })
    },

    setInfo: function (schedule) {
      this.subtitle = '수업 스케줄 확인'
      if (schedule) {
        this.schedule = schedule
        this.schedule.booked = 0
      }
      this.edit = null

      let lesson = this.getLesson(this.schedule.lesson)

      this.columns[0].text = this.schedule.date
      this.columns[1].text = this.schedule.time
      this.columns[2].text = this.schedule.capacity
      this.columns[3].text = lesson.text
      this.columns[4].text = util.getItem(this.couponTypes, lesson.coupon_type).text + ` (${lesson.coupons}매)`
      this.columns[5].text = this.getInstructor(this.schedule.instructor).text
      this.columns[6].text = this.schedule.memo
      this.columns[7].text = this.schedule.cancel + '시간 전에 가능'
      this.columns[8].text = new Date(this.schedule.cdate.replace(' ', 'T') + ':00').toLocaleString()
      this.columns[9].text = this.schedule.mdate ? new Date(this.schedule.mdate.replace(' ', 'T') + ':00').toLocaleString() : ''
      if (this.schedule.cancel == 24) this.columns[7].text = '하루 전에 가능'
      if (this.schedule.cancel == 48) this.columns[7].text = '이틀 전에 가능'

      axios.get(`/api/schedule/find/${this.studio}/${this.schedule.date}/${this.schedule.time}`)
      .then(response => {
        if (response.data.error) {
          console.log(response.data.error)
        }
        else if (response.data.schedule) {
          this.schedule.booked = response.data.schedule.booked
          if (this.schedule.booked) {
            this.columns[2].text += ` (예약: ${this.schedule.booked}명)`
          }
        }
      })
    },

    setCoupon: function () {
      let lesson = this.getLesson(this.edit.lesson)
      this.columns[4].text = util.getItem(this.couponTypes, lesson.coupon_type).text
    },

    add: function () {
      this.subtitle = '수업 스케줄 추가'
      this.schedule = null
      this.edit = this.schedules[0] ? JSON.parse(JSON.stringify(this.schedules[0])) : {}
      this.edit.id = null
      this.edit.cdate = null
      this.edit.mdate = null
      this.edit.booked = null
      this.setCoupon()
    },

    modify: function () {
      this.subtitle = '수업 스케줄 수정'
      this.edit = JSON.parse(JSON.stringify(this.schedule))
    },

    cancel: function () {
      this.edit = null
    },

    validate: function () {
      if (!this.edit.date) return false
      if (!this.edit.time) return false
      if ( this.edit.capacity <= 0) return false
      if (!this.edit.lesson) return false
      if (!this.edit.instructor) return false
      return true
    },

    insert: function () {
      if (!this.validate()) return
      let params = new URLSearchParams()
      params.append('date', this.edit.date)
      params.append('time', this.edit.time)
      params.append('capacity', this.edit.capacity)
      params.append('lesson', this.edit.lesson)
      params.append('instructor', this.edit.instructor)
      params.append('memo', this.edit.memo ? this.edit.memo : '')
      params.append('cancel', this.edit.cancel)
      axios.post('/api/schedule/insert/' + this.studio, params, util.headers)
      .then(response => {
        if (response.data.error) {
          console.log(response.data.error)
          if (response.data.error == 'Exists') {
            alert('같은 일시에 수업이 있습니다. 다른 시간을 선택해주세요.')
          }
        }
        else {
          this.refresh()
        }
      })
    },

    update: function () {
      if (!this.validate()) return
      if (this.edit.capacity < this.edit.booked) {
        alert('정원이 예약인원보다 적습니다.')
        return
      }
      let params = new URLSearchParams()
      params.append('id', this.edit.id)
      params.append('date', this.edit.date)
      params.append('time', this.edit.time)
      params.append('capacity', this.edit.capacity)
      params.append('lesson', this.edit.lesson)
      params.append('instructor', this.edit.instructor)
      params.append('memo', this.edit.memo ? this.edit.memo : '')
      params.append('cancel', this.edit.cancel)
      axios.post('/api/schedule/update/', params, util.headers)
      .then(response => {
        if (response.data.error) {
          console.log(response.data.error)
        }
        else {
          this.refresh()
        }
      })
    },

    remove: function () {
      if (!confirm(this.schedule.date + ' ' + this.schedule.time + ' 수업을 정말로 삭제하시겠습니까?')) {
        return
      }
      let params = new URLSearchParams()
      params.append('id', this.schedule.id)
      axios.post('/api/schedule/delete/', params, util.headers)
      .then(response => {
        if (response.data.error) {
          console.log(response.data.error)
        }
        else if (response.data.result == 'success') {
          let index = this.schedules.map(schedule => { return schedule.id }).indexOf(this.schedule.id)
          if (index >= 0) {
            this.schedules.splice(index, 1)
            this.schedule = null
          }
        }
      })
    },
    
    change: function (studio) {
      this.studio = studio
      this.refresh()
    }
  },

  created () {
    console.clear()
    let json = localStorage.getItem('login')
    if (json) {
      this.login = JSON.parse(json)
      this.studio = this.login.studio
    }
    if (this.login) {
      this.$emit('login', this.login)

      util.getCouponTypes((couponTypes, error) => {
        if (error) console.log(error)
        this.couponTypes = couponTypes
      })

      util.getLessons(this.login.studio, (lessons, error) => {
        if (error) console.log(error)
        this.lessons = lessons

        util.getInstructors(0, (instructors, error) => {
          if (error) console.log(error)
          this.instructors = instructors

          this.refresh()
        })
      })
    }
    else {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.ml--15 {
    margin-left: -15px;
}
.mt--5 {
    margin-top: -5px;
    margin-right: 5px;
}
.mb--20 {
    margin-bottom: -20px;
}
.mb--40 {
    margin-bottom: -40px;
}
.font-13 {
  font-size: 13px;
}
.font-14 {
  font-size: 14px;
}
</style>
